module.exports = __webpack_public_path__ + "static/img/xxxx2_xxhdpi.d30c3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xxxx2_xxhdpi.png
// module id = A+AQ
// module chunks = 1